var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"MUTE","name":"MUTE","data-vcode":"MUTE","disabled":"","aria-label":`${_vm.$t('muteButton')}`}},[_c('img',{attrs:{"src":"/images/icons/mute.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('muteButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }